import React from 'react';
import { Drawer, Button } from 'antd';
import { COLORS } from '../../../constants/colors';
import { StyledSelect } from '../styled';

const { Option } = StyledSelect;

const FilterDrawer = ({
  visible,
  onClose,
  roleFilter,
  statusFilter,
  onRoleChange,
  onStatusChange
}) => {
  const handleApply = () => {
    onClose();
  };

  const handleClear = () => {
    onRoleChange('all');
    onStatusChange('all');
  };

  return (
    <Drawer
      title="Filter Users"
      placement="right"
      onClose={onClose}
      open={visible}
      width={300}
      styles={{
        body: { padding: '16px' }
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div className="filter-group">
          <label className="filter-label" style={{ 
            display: 'block', 
            marginBottom: '8px', 
            fontWeight: 600, 
            color: COLORS.textDark 
          }}>
            Role
          </label>
          <StyledSelect
            value={roleFilter}
            onChange={onRoleChange}
            style={{ width: '100%' }}
            placeholder="Select role"
          >
            <Option value="all">All Roles</Option>
            <Option value="admin">Admin</Option>
            <Option value="user">User</Option>
            <Option value="volunteer">Volunteer</Option>
          </StyledSelect>
        </div>
        
        <div className="filter-group">
          <label className="filter-label" style={{ 
            display: 'block', 
            marginBottom: '8px', 
            fontWeight: 600, 
            color: COLORS.textDark 
          }}>
            Status
          </label>
          <StyledSelect
            value={statusFilter}
            onChange={onStatusChange}
            style={{ width: '100%' }}
            placeholder="Select status"
          >
            <Option value="all">All Statuses</Option>
            <Option value="active">Active</Option>
            <Option value="inactive">Inactive</Option>
            <Option value="locked">Locked</Option>
          </StyledSelect>
        </div>
        
        <div style={{ 
          display: 'flex', 
          gap: '8px', 
          marginTop: '20px',
          paddingTop: '20px',
          borderTop: `1px solid ${COLORS.border}`
        }}>
          <Button
            onClick={handleClear}
            style={{ flex: 1, height: '40px' }}
          >
            Clear
          </Button>
          
          <Button
            type="primary"
            onClick={handleApply}
            style={{
              flex: 1,
              height: '40px',
              background: COLORS.$primaryBlue,
              borderColor: COLORS.$primaryBlue
            }}
          >
            Apply
          </Button>
        </div>
      </div>
    </Drawer>
  );
};

export default FilterDrawer;
